"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ImgSwiper = void 0;
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("swiper/react");
var _swiper = require("swiper");
var _reactLazyLoadImageComponent = require("react-lazy-load-image-component");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _material = require("@mui/material");
var _ArrowBackIosRounded = _interopRequireDefault(require("@mui/icons-material/ArrowBackIosRounded"));
var _ArrowForwardIosRounded = _interopRequireDefault(require("@mui/icons-material/ArrowForwardIosRounded"));
var _paulCorePackage = require("paul-core-package");
var _reactRedux = require("react-redux");
var _ImgSwiperModule = _interopRequireDefault(require("../../styles/components/ImgSwiper.module.css"));
var _constants = require("../../utils/constants");
var _function = require("../../utils/function");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const ImgSwiper = _ref => {
  let {
    fullScreen = false,
    imgSizeKey,
    imgList,
    defaultImg,
    type
  } = _ref;
  const id = _paulCorePackage.functions.getStringId();
  const webpSupport = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getWebpSupport);
  const hasImages = Boolean(imgList.length);
  const swiperImgList = hasImages ? imgList : [{
    [imgSizeKey]: defaultImg
  }];
  const {
    source: sourceURL
  } = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getUrls);
  const defaultImgUrl = (0, _react.useMemo)(() => (0, _function.getDefaultImg)({
    sourceURL,
    type,
    webpSupport,
    imgSize: _paulCorePackage.constants.imgSizeKeys.original
  }), [sourceURL, type, webpSupport]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, hasImages && /*#__PURE__*/_react.default.createElement(StyledSwiperBtn, {
    className: "image-swiper-button-prev".concat(id),
    sx: {
      margin: fullScreen ? '0 50px' : '0 9px'
    }
  }, /*#__PURE__*/_react.default.createElement(_ArrowBackIosRounded.default, null)), hasImages && /*#__PURE__*/_react.default.createElement(StyledSwiperBtn, {
    sx: {
      right: 0,
      margin: fullScreen ? '0 50px' : '0 9px'
    },
    className: "image-swiper-button-next".concat(id)
  }, /*#__PURE__*/_react.default.createElement(_ArrowForwardIosRounded.default, null)), /*#__PURE__*/_react.default.createElement(_react2.Swiper, {
    style: {
      '--swiper-pagination-color': _constants.colors['main-color-cl-01'],
      '--swiper-pagination-bullet-inactive-color': _constants.colors['main-color-cl-19'],
      '--swiper-pagination-bullet-inactive-opacity': 1
    },
    pagination: {
      clickable: true
    },
    navigation: {
      prevEl: ".image-swiper-button-prev".concat(id),
      nextEl: ".image-swiper-button-next".concat(id),
      disabledClass: _ImgSwiperModule.default.swiper_button_disabled
    },
    modules: [_swiper.Navigation, _swiper.Pagination],
    className: "".concat(_ImgSwiperModule.default.swiper, " ").concat(fullScreen ? _ImgSwiperModule.default.fullScreen : '')
  }, swiperImgList.map(imgObj => /*#__PURE__*/_react.default.createElement(_react2.SwiperSlide, {
    className: _ImgSwiperModule.default.swiper_slide,
    key: imgObj[imgSizeKey]
  }, /*#__PURE__*/_react.default.createElement(_reactLazyLoadImageComponent.LazyLoadImage, {
    wrapperClassName: "".concat(_ImgSwiperModule.default.lazy_load_image, " ").concat(fullScreen ? _ImgSwiperModule.default.fullScreen : ''),
    effect: "blur",
    src: (0, _function.getSupportedImg)({
      webpSupport,
      urls: imgObj,
      imgSizeKey: _paulCorePackage.constants.imgSizeKeys.original,
      defaultImg: defaultImgUrl
    }),
    onError: event => {
      // eslint-disable-next-line no-param-reassign
      event.target.src = defaultImgUrl;
    }
  })))));
};
exports.ImgSwiper = ImgSwiper;
const StyledSwiperBtn = (0, _material.styled)(_material.IconButton)(() => ({
  backgroundColor: _constants.colors['main-color-cl-19'],
  position: 'absolute',
  zIndex: 2,
  top: '50%',
  transform: 'translateY(-50%)',
  opacity: 0.85,
  color: _constants.colors['main-color-cl-01'],
  '&:hover': {
    opacity: 1,
    backgroundColor: _constants.colors['main-color-cl-19']
  }
}));
ImgSwiper.propTypes = {
  fullScreen: _propTypes.default.bool,
  imgSizeKey: _paulCorePackage.customPropTypes.imgSizeKeyType,
  imgList: _paulCorePackage.customPropTypes.hasimagesType,
  defaultImg: _propTypes.default.string,
  type: _propTypes.default.string.isRequired
};